// ----------------------------------------------------------------------------
// Component: Content Cards
// ----------------------------------------------------------------------------
//
// Section displaying a default card consisting of an image,
// title, content and button. It displays a 1, 2 or 3 column grid.
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------
import Swiper from 'swiper';
import { Scrollbar, A11y, Keyboard } from 'swiper/modules';
import 'snippets/card/card';

// Style includes
import 'swiper/css';
import 'swiper/css/scrollbar';
import 'swiper/css/a11y';
import 'swiper/css/keyboard';
import './_content-cards.scss';

// -------------------------------------
// Variables
// -------------------------------------
var CAROUSEL_SELECTOR = '.carousel--content-cards';
var CAROUSEL_CLASS = 'carousel--content-cards';
var CAROUSEL_SECTION_SELECTOR = '.content-cards';
var CAROUSEL_SECTION_CLASS = 'content-cards';
var CAROUSEL_SCROLLBAR_SELECTOR = '.swiper-scrollbar';

// -------------------------------------
// Hooks
// -------------------------------------
document.querySelectorAll(CAROUSEL_SECTION_SELECTOR).forEach((element, index) => {
  // Generate unique class for each collection list slider
  element.querySelector(CAROUSEL_SELECTOR).classList.add("".concat(CAROUSEL_CLASS, "-").concat(index));

  // Generate unique btn classes for slider arrows
  element.querySelector(CAROUSEL_SCROLLBAR_SELECTOR).classList.add("".concat(CAROUSEL_CLASS, "-scrollbar-").concat(index));
  var swiper = new Swiper(".".concat(CAROUSEL_CLASS, "-").concat(index), {
    // Optional parameters
    modules: [Scrollbar, A11y, Keyboard],
    slidesPerView: 1.5,
    spaceBetween: 8,
    observer: true,
    observeParents: true,
    a11y: true,
    watchOverflow: true,
    // Do not turn into sliders if number of slides is less than slidesPerView.

    breakpoints: {
      // when window width is >= 768px
      768: {
        slidesPerView: 4
      }
    },
    scrollbar: {
      el: "".concat(CAROUSEL_SELECTOR, "-scrollbar-").concat(index),
      hide: false,
      draggable: true
    }
  });
  swiper.slides.forEach(function (slide, index) {
    var slideLink = slide.querySelector('a');
    slideLink.addEventListener('focus', function () {
      swiper.slideTo(index);
    });
  });
});